export var SearcherModalProductType;
(function(SearcherModalProductType) {
    SearcherModalProductType["ROUNDTRIP"] = "ROUNDTRIP";
    SearcherModalProductType["ONEWAY"] = "ONEWAY";
    SearcherModalProductType["FLIGHTHOTEL"] = "FLIGHTHOTEL";
    SearcherModalProductType["TRAINHOTEL"] = "TRAINHOTEL";
    SearcherModalProductType["FERRYHOTEL"] = "FERRYHOTEL";
    SearcherModalProductType["FERRY"] = "FERRY";
    SearcherModalProductType["ACTIVITIES"] = "ACTIVITIES";
    SearcherModalProductType["SEARCHER_TRAIN_HOTEL"] = "SEARCHER_TRAIN_HOTEL";
    SearcherModalProductType["SEARCHER_FERRY_HOTEL"] = "SEARCHER_FERRY_HOTEL";
    SearcherModalProductType["SEARCHER_FLIGHT_HOTEL"] = "SEARCHER_FLIGHT_HOTEL";
    SearcherModalProductType["SEARCHER_ACTIVITIES"] = "SEARCHER_ACTIVITIES";
})(SearcherModalProductType || (SearcherModalProductType = {}));

//# sourceMappingURL=types.js.map